<template>
<div class="accordion w-100" id="accordionFlushExample">
        <div class="info-accordion-item accordion-item">
            <h2 class="info-accordion-header accordion-header" id="flush-headingOne">
                <button class="info-accordion-button accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                    <span class="ms-2 me-3" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" aria-hidden="true" focusable="false"><g clip-path="url(#a)"><path fill="#006ab2" d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18"/><path fill="#fff" d="M9.807 6.75q.441.001.44.61v4.722q-.001.8.299.799c.042 0 .12-.013.226-.039q.162-.038.273-.038.659 0 .658.816 0 1.08-.927 1.08c-.107 0-.397-.026-.88-.077a10 10 0 0 0-1.003-.047q-.282 0-.832.064a8 8 0 0 1-.816.064.89.89 0 0 1-.687-.29q-.27-.287-.27-.748.002-.894.752-.892l.406.094q.065.015.111.017c.188 0 .282-.29.282-.88v-2.54q-.001-.894-.265-.892c-.03 0-.128.026-.282.077q-.157.03-.252.03c-.503 0-.751-.29-.751-.88q0-.473.269-.76a.92.92 0 0 1 .704-.29q.172.001.504.047.549.077.88.077.269 0 .691-.064.424-.064.47-.064zm-.892-.598q-.582 0-1.004-.422a1.38 1.38 0 0 1-.422-1.004c0-.384.136-.734.414-1.012A1.38 1.38 0 0 1 8.915 3.3q.595 0 1.012.414.415.417.414 1.012 0 .596-.414 1.012a1.38 1.38 0 0 1-1.012.414"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h18v18H0z"/></clipPath></defs></svg>
                    </span>
                    <strong>Bitte beachten Sie</strong>
                </button>
            </h2>

            <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                

                
                <div class="accordion-body ms-2">
                    <p id="arn-info-familie">Bei der <strong>Familienversicherung</strong> ist der Antragsteller versichert. Zusätzlich besteht Versicherungsschutz für folgende mit ihm in häuslicher Gemeinschaft lebenden Personen:</p>
                    <ul class="listeimp">
                        <li>ein Ehegatte oder ein Lebenspartner sowie</li>
                        <li>die Kinder (auch Adoptiv-, Pflege- und Stiefkinder) bis zur Vollendung des 25. Lebensjahres</li>
                    </ul>
                    <p id="arn-info-visum">Sollte die Auslandskrankenversicherung bezüglich einer Visumbeantragung benötigt werden, empfehlen wir den Abschluss der <strong>Einzelversicherung</strong>, da im Versicherungsschein der Familienversicherung nur der Name des Versicherungsnehmers angezeigt wird.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

</script>

<style scoped>
/* Überschreibt die externe .collapse Regel mit höherer Spezifität */
.accordion-collapse.collapse {
    visibility: visible !important;
    display: block;
}

.accordion-collapse.collapse:not(.show) {
    display: none;
}

.accordion-collapse.collapse.show {
    display: block;
}
#arn-info-familie {
    font-size: 1rem !important;
    margin-bottom: 0;
}

#arn-info-visum {
    font-size: 1rem !important;
    margin-top: 0.75rem;
    margin-bottom: 0;
}

.listeimp {
    list-style-type: disc !important;
    padding-left: 2rem;
    margin-bottom: 0;
}
</style>